import { constants } from "../../../constants";

export default class FreeRoundsFinished {
    constructor(gb) {
        Object.assign(this, { gb });
    }
    GREENTUBE_handler(msg) {
        this.gb.emitters.emit.game.customMsg(msg);
        this.gb.queryParams.freeRounds = false;
    }

    _default() {
        if(this.gb.api && this.gb.api.modules && this.gb.api.modules.superWheel.instanceAvailable) {
            this.gb.api.modules.superWheel.enableWheel();
        }
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.GREENTUBE:
                event["freeSpinsFinished"] = this.GREENTUBE_handler;
                break;
            case constants.HNR:
                event["freeSpinEnded"] = this._default;
                break;
            default:
                event["freeRoundsEnd"] = this._default;
        }

        return event;
    }
}